export const firebase_config = {
    apiKey: 'AIzaSyCKh85-NYmmxnNJJzaA6y90zVBct0l6jhw',
    authDomain: 'all-access-v09.firebaseapp.com',
    projectId: 'all-access-v09',
    storageBucket: 'all-access-v09.appspot.com',
    messagingSenderId: '44055280112',
    appId: '1:44055280112:web:90f5b24f130faa80770535',
    measurementId: 'G-Y1QQKNS4J0',
};
